export const setCode = code => ({
  type: 'SET_CODE',
  code: code
})
